import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./auth/login/login.component').then((m) => m.LoginComponent),
    data: {
      title: 'Iniciar Sessión',
    },
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./auth/register/register.component').then(
        (m) => m.RegisterComponent
      ),
    data: {
      title: 'Registro',
    },
  },
  {
    path: 'forgot',
    loadComponent: () =>
      import('./auth/forgot/forgot.component').then((m) => m.ForgotComponent),
    data: {
      title: 'Olvidó la Contraseña?',
    },
  },
  {
    path: 'home',
    loadChildren: () => import('./views/home/routes').then((m) => m.HOME),
    data: {
      title: 'Inicio',
      preload: true,
    },
  },
  {
    path: 'order',
    loadChildren: () => import('./views/orders/routes').then((m) => m.ORDERS),
    data: {
      title: 'Ordenes Realizadas',
      preload: true,
    },
  },
  {
    path: 'suggestion',
    loadChildren: () =>
      import('./views/suggestion/routes').then((m) => m.SUGGESTION),
    data: {
      title: 'Sugerencias',
    },
  },
  {
    path: 'history',
    loadChildren: () => import('./views/patient/routes').then((m) => m.PATIENT),
    data: {
      title: 'Pacientes',
      preload: true,
    },
  },
  {
    path: 'account',
    loadChildren: () => import('./views/account/routes').then((m) => m.ACCOUNT),
    data: {
      title: 'Administracion de Cuenta',
      preload: true,
    },
  },
  {
    path: 'bookings',
    loadChildren: () =>
      import('./views/bookings/routes').then((m) => m.BOOKINGS),
    data: {
      title: 'Citas',
    },
  },
  {
    path: 'viewer',
    loadChildren: () => import('./viewer/viewer.routes').then((m) => m.VIEWER_ROUTES),
    data: {
      title: 'Visor DICOM',
    },
  },
  { path: '**', redirectTo: 'home' },
];
